import { useModuleEnabled } from "../access/useFeatureAccess";
import { featureFlags } from "../config/featureFlags";

/**
 * Whether the Priority Worklist nav tab should render. GATED on BOTH
 * featureFlags.patientPriorityIndex (VITE_FEATURE_PATIENT_PRIORITY_INDEX,
 * default off — module unpublished, see worklist/WorklistPage.tsx) AND
 * persona (useModuleEnabled("PriorityWorklist")) — mirrors App.tsx's
 * WorklistGate so the nav affordance and the route's actual accessibility
 * never disagree.
 *
 * Lives in its OWN module rather than inline in AppLayout.tsx so
 * `useAdtBellVisible.ts` can depend on it (the ADT bell must not be visible
 * unless the worklist it hands off to is ALSO visible — see that hook's
 * doc) without creating a circular `AppLayout.tsx <-> useAdtBellVisible.ts`
 * import. AppLayout.tsx re-exports this for its existing call sites
 * (TabbedAppShell.tsx), so nothing else needed to change.
 */
export function useTopNavWorklistVisible(): boolean {
  const moduleEnabled = useModuleEnabled("PriorityWorklist");
  return featureFlags.patientPriorityIndex && moduleEnabled;
}
